var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutoSuggest',{staticClass:"mb-4 platforms-filter",attrs:{"label":_vm.label,"multiple":"","only-unique":"","source":_vm.platforms,"name":"platforms","placeholder":this.$t(
      '_web_competitions_tournaments-list-all-platforms',
      'All platforms'
    ),"display-property":"name","show-on-focus":true},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }